import React from 'react';
import { useState } from 'react';
import { GlobalVariables } from '../../globalVar';
import customAxios from '../../utils/customAxios';
import { getToast } from '../../utils/toastConfig';
import {
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import {
  faCircleChevronLeft,
  faTimes,
  faWarning,
} from '@fortawesome/pro-regular-svg-icons';
import variables from '../../scss/_variables.scss';
import { ThemeProvider } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useEffect } from 'react';

const theme = createTheme({
  palette: {
    primary: {
      main: variables.redDabi,
    },
  },
});

const DeleteRoleLicensesModal = ({
  roleConfig,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [roleInfo, setRoleInfo] = useState({
    id: null,
    role_id: null,
    role_name: '',
    max_licenses: '',
    current_licenses: '',
    remaining_licenses: '',
  });

  // Translation hooks
  const { modalYesString, modalNoString } = useTranslationHook();

  useEffect(() => {
    if (showModal) {
      setRoleInfo(roleConfig);
    }
  });

  const handleClose = () => {
    setShowModal(false);
    refreshData();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const endpoint = `${GlobalVariables.getURL()}licenses/roles/licenses/delete/${
        roleInfo.id
      }`;

      const response = await customAxios.delete(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        getToast({ status: 'success', title: response.data.message });
        handleClose();
      }
    } catch (error) {
      console.log('🚀 ~ handleSubmit ~ error:', error);
      getToast({
        status: 'error',
        title: error.response.data.message,
        duration: 4,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={showModal} maxWidth='md' fullWidth onClose={handleClose}>
        <DialogTitle>
          <Typography className='inventory-movmodal-title'>
            Eliminar licencias
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h5'>
                ¿Seguro que desea eliminar la configuración de estas licencias?
              </Typography>
            </Grid>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={6}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>ID:</span> {roleInfo.id}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>
                    {'Nombre del rol'}:
                  </span>{' '}
                  {roleInfo.role_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={6}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>
                    {'Licencias totales'}:
                  </span>{' '}
                  {roleInfo.max_licenses}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='h6'>
                  <span style={{ fontWeight: 'bold' }}>
                    {'Licencias en uso'}:
                  </span>{' '}
                  {roleInfo.current_licenses}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <button
            className='modal-button'
            onClick={handleSubmit}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faWarning} /> {modalYesString}
          </button>
          <button
            className='modal-button no'
            onClick={handleClose}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
          </button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default DeleteRoleLicensesModal;
